import React from 'react';

const exam = () => {
  return (
    <div>
      exam
    </div>
  );
}

export default exam;
